<template>
  <div>
    <p>{{ label }}</p>
    <input class="" type="time" v-model="startTime" name="commonTimeInput" />
    <template v-if="type == 'timeBetween'">
      ~
      <input class="" type="time" v-model="endTime" />
    </template>
  </div>
</template>

<script>
import { ref, watch } from "@vue/runtime-core";
export default {
  props: {
    label: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "time", // time/timeBetween
    },
  },
  emits: ["update:getValue"],
  setup(props, { emit }) {
    const startTime = ref();
    const endTime = ref();

    watch(
      startTime,
      (newValue) => {
        if (props.type == "timeBetween") {
          emit("update:getValue", {
            startTime: newValue,
            endTime: endTime.value,
          });
        } else {
          emit("update:getValue", newValue);
        }
      },
      { deep: true }
    );

    if (props.type == "timeBetween") {
      watch(
        endTime,
        (newValue) => {
          emit("update:getValue", {
            startTime: startTime.value,
            endTime: newValue,
          });
        },
        { deep: true }
      );
    }

    return {
      startTime,
      endTime,
    };
  },
};
</script>

<style scoped>
p {
  margin-bottom: 10px;
}
input[type="time"] {
  max-width: 9rem;
  height: 2.375rem;
  font-size: 0.875rem;
  border: 2px solid rgb(255, 255, 255);
  box-shadow: rgba(0, 0, 0, 0.2) 0px 1px 3px 0px;
  color: rgb(95, 95, 95);
}
</style>
